import { render } from 'preact';
import { MyQueriesMenuApp } from '../components/MyQueriesMenuApp.jsx';
import '../styles/portal-recent-queries.css';

const roots = document.querySelectorAll('[data-pp-my-queries-root]');

roots.forEach((root) => {
  render(<MyQueriesMenuApp />, root);
});
